module.exports = "/_next/static/images/golf@3x-11510e16ca4bd0999eb19f88484e6ea8.png";